/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmPromptsListVersions } from "../../funcs/llmPromptsListVersions.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListPromptVersionsRequest$inboundSchema,
};

export const tool$llmPromptsListVersions: ToolDefinition<typeof args> = {
  name: "llm-prompts-list-versions",
  description: `List versions

Returns the version history of a prompt, ordered by version number.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmPromptsListVersions(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
